export default "__VITE_ASSET__8d20cbf8__"